/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import {
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { Space, Tag, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { CourseLineTable } from '@/domains/course-lines/entities';
import { OperationMethodTable } from '@/domains/operation-methods/entities';
import { GetListOperationMethod } from '@/modules/operation-methods/viewmodels';

interface TableProps {
  onSelectItem: (id: string) => void;
  onRemoveItem?: (id: string) => void;
}

const TableColumn = ({ onSelectItem, onRemoveItem }: TableProps) => {
  const [operationMethods, setOperationMethods] = useState<OperationMethodTable[]>([]);
  const { operationMethodData, actionGetAllOperationMethod } = GetListOperationMethod();

  useEffect(() => {
    actionGetAllOperationMethod();
  }, []);

  useEffect(() => {
    if (operationMethodData) {
      setOperationMethods(operationMethodData);
    }
  }, [operationMethodData]);

  // Helper function to get operation method name from ID
  const getOperationMethodName = (id: string) => {
    const method = operationMethods.find((method) => method.id === id);
    return method ? method.name : id;
  };

  const columns: ColumnsType<CourseLineTable> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Base Price',
      dataIndex: 'basePrice',
      key: 'basePrice',
      render: (price) =>
        price !== undefined && price !== null ? `${price.toLocaleString('vi-VN')}` : '-',
    },
    {
      title: 'Operation Methods',
      dataIndex: 'operationMethods',
      key: 'operationMethods',
      render: (operationMethodIds) => (
        <>
          {operationMethodIds && operationMethodIds.length > 0
            ? operationMethodIds.map((id: string) => (
                <Tag color='blue' key={id}>
                  {getOperationMethodName(id)}
                </Tag>
              ))
            : '-'}
        </>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (
        <>
          {isActive ? (
            <Tag icon={<CheckCircleOutlined />} color='success'>
              Active
            </Tag>
          ) : (
            <Tag icon={<CloseCircleOutlined />} color='error'>
              Inactive
            </Tag>
          )}
        </>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Tooltip title='Edit'>
            <EditOutlined
              className='text-primary'
              onClick={() => onSelectItem(record.id)}
              style={{ cursor: 'pointer' }}
            />
          </Tooltip>
          {onRemoveItem && (
            <Tooltip title='Delete'>
              <DeleteOutlined
                className='text-danger'
                onClick={() => onRemoveItem(record.id)}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  return columns;
};

export default TableColumn;
